import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import Toasted from 'vue-toasted';
import store from './store'

Vue.use(Toasted)
Vue.config.productionTip = false

import http from './http'

Vue.prototype.$http = http

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
